import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import ProductLandingPage from './ProductLandingPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FFC107', // Yellow - school primary color
      light: '#FFD54F',
      dark: '#FFA000',
      contrastText: '#000000', // Black text on yellow
    },
    secondary: {
      main: '#212121', // Black
      light: '#424242', // Dark gray
      dark: '#000000',
      contrastText: '#ffffff',
    },
    background: {
      default: '#FAFAFA', // Light gray
      paper: '#FFFFFF', // White
    },
    text: {
      primary: '#212121', // Black
      secondary: '#616161', // Gray
    },
    grey: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#E0E0E0',
      400: '#BDBDBD',
      500: '#9E9E9E',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '2.5rem', fontWeight: 700 },
    h2: { fontSize: '2rem', fontWeight: 700 },
    h3: { fontSize: '1.75rem', fontWeight: 600 },
    h4: { fontSize: '1.5rem', fontWeight: 600 },
    h5: { fontSize: '1.25rem', fontWeight: 600 },
    h6: { fontSize: '1rem', fontWeight: 600 },
  },
});

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <ProductLandingPage />
    <ToastContainer position="top-right" autoClose={4000} />
  </ThemeProvider>
);

export default App;
